import { render, staticRenderFns } from "./Telmax.vue?vue&type=template&id=1605b62c&"
import script from "./Telmax.vue?vue&type=script&lang=js&"
export * from "./Telmax.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports